export function storeSignature(signatureObject: string, walletAddress: string) {
  try {
    const parsedSignature = JSON.parse(signatureObject);

    if (!parsedSignature.chainID) {
      throw new Error('Invalid signature: Missing chainID.');
    }

    const chainId = parsedSignature.chainID;
    const storageKey = `signatures-${walletAddress}-${chainId}`;

    // Get existing signatures or initialize an empty array
    if (localStorage.getItem(storageKey)) {
      // This key is not used anywhere and it takes up very large space in local storage, so we should remove it for all users.
      localStorage.removeItem(storageKey);
    }
  } catch (error) {
    console.error('Error storing signature:', error);
  }
}
